<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import * as axios from "axios";
const USERS_API_URL = process.env.VUE_APP_API_URL + 'users/';
export default {
    page: {
        title: 'Signup',
        meta: [{ name: 'description', content: `Sign up to ${appConfig.title}` }],
    },
    components: { 
      Layout,
       },
    data() {
        return {
            name: '',
            lastName: '',
            companyName: '',
            email: '',
            password: '',
            country: '',
            newUserId: '',
            policyIsChecked: false,
            tryingToRegister: false,
            isRegisterError: false,
            isRegistered: false,
            registerError: null,
            isSendingEmail: false,
            emailIsSent: false,
            showNotification: false
        }
    },
    computed: {

    },
    methods: {
      ...authMethods,
      async tryToRegisterIn(){
        this.tryingToRegister = true;
        this.registerError = null;
        this.isRegisterError = false;
        try {
          this.isRegisterError = false;
          const response = await this.signUp({
                name: this.name,
                lastName: this.lastName,
                email: this.email,
                companyName: this.companyName,
                country: this.country,
                password: this.password
          })
          this.newUserId = response.createdUser.id
          
          
        } catch (error) {
          this.tryingToRegister = false;
          this.registerError = (error.response? error.response.data.message : '') || error;
          this.isRegisterError = true;
          console.log(error)
        }
        
        /* send email to new user to activate his/her account */
        await axios(
            USERS_API_URL + this.newUserId + '/activate-account'
          )
          this.isRegistered = true;
          this.tryingToRegister = false;
          this.emailIsSent = true;
      }
        
    }

}
</script>

<template>
  <Layout>
    <div class="row justify-content-center white-text top-space">
      <div class="col-md-8 col-lg-7 col-xl-6">
        <div class="">
          <div class="card-body p-4">
            <div class="text-center w-100 m-auto">
              <a href="/">
                <span
                ><img src="@assets/images/logo-white.png" alt="" height="52"
                /></span>
              </a>
              <p class="mb-4 mt-3 secondary-text" v-if="!isRegistered"
                >Create your free account and unblock your opportunities.</p
              >
              <p class="mb-4 mt-5" v-if="emailIsSent"
                > <strong class="highlight-text">Check your email!</strong> <br/> We've sent you an activation email, please enter your email to complete it.</p
              >
            </div>

            <b-alert v-model="isRegisterError" variant="danger" dismissible class="alert-btn error">
              {{registerError}}
            </b-alert>

            <b-form @submit.prevent="tryToRegisterIn">
            <div class="row">
              <b-form-group
                id="fullname-group"
                label-for="name"
                class="col-lg-6"
                v-if="!isRegistered"
              >
              <label for="name">
              </label>
                <i class=""><img src="@assets/images/user.png" alt="" height=""/></i>
                <input
                  id="name"
                  v-model="name"
                  type="text"
                  required
                  placeholder="First name"
                  class="input"
                ></input>
              </b-form-group>

              <b-form-group
                      id="lastName-group"
                      label-for="lastName"
                      class="col-lg-6"
                      v-if="!isRegistered"
              >
              <label for="lastName">
              </label>
                <i class=""><img src="@assets/images/user-blank.png" alt="" height=""/></i>
                <input
                        id="lastName"
                        v-model="lastName"
                        type="text"
                        required
                        placeholder="Last name"
                        class="input"
                ></input>
              </b-form-group>
            </div>

              <b-form-group
                id="email-group"
                label-for="email"
                v-if="!isRegistered"
              >
              <label for="email">
              </label>
                <i class=""><img src="@assets/images/email.png" alt="" height=""/></i>
                <input
                  id="email"
                  v-model="email"
                  type="email"
                  required
                  placeholder="Email"
                  class="input"
                ></input>
              </b-form-group>
              <b-form-group
                      id="companyName-group"
                      label-for="companyName"
                      v-if="!isRegistered"
              >
              <label for="companyName">
              </label>
                <i class=""><img src="@assets/images/company.png" alt="" height=""/></i>
                <input
                        id="companyName"
                        v-model="companyName"
                        type="text"
                        required
                        placeholder="Company"
                        class="input"
                ></input>
              </b-form-group>
              

              <b-form-group id="country-group" label-for="country" class="mb-2" v-if="!isRegistered">
              <label for="country">
              </label>
              <i class=""><img src="@assets/images/country.png" alt="" height=""/></i>
              <country-select v-model="country" :country="country" id="country" :countryName="true" placeholder="Country" className="custom-select select" required/>
              </b-form-group>
            

              <b-form-group
                id="password-group"
                label-for="password"
                v-if="!isRegistered"
                class="mb-4"
              >
              <label for="password">
              </label>
              <i class="password-icon"><img src="@assets/images/key.png" alt="" height=""/></i>
                <input
                  id="password"
                  v-model="password"
                  type="password"
                  required
                  placeholder="Password"
                  minlength="8"
                  pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$"
                  class="input"
                  @focus="showNotification = true"
                ></input>
                <p class="ml-3 mr-3 mt-2 password-notifacation" v-if="showNotification"><small>Make sure your password contains at least 8 characters including a number and a lowercase letter</small> </p>
              </b-form-group>
              
              <b-form-group
                v-if="!isRegistered"
                class="mb-4 ml-2 policy"
              >
              <input
                id="policy"
                type="checkbox"
                name="policy"
                :checked="false"
                required
                class="policy"
              />               
                I agree to Unblockia's <a href="#">Privacy Policy</a>
                </b-form-group>



              <b-form-group class=" text-center">
                <b-button type="submit"  class="change-pwd-btn" v-if="!isRegistered && !tryingToRegister"
                  
                  ></b-button
                >
                <div class="text-center"  v-if="tryingToRegister && !isRegistered">
                <b-spinner label="Text Centered" class="m-2" variant="light" role="status"></b-spinner>
                </div>
              </b-form-group>


             <!--  <b-form-group class="mt-4" v-if="tryingToRegister && !isRegistered">
                <b-button
                    disabled
                    class="btn-block"
                >
                    <b-spinner small type="grow"></b-spinner
                    >&nbsp;&nbsp;Signing up...
                  </b-button>
              </b-form-group> -->
              
            </b-form>
          </div>

          
          <!-- end card-body -->
        </div>
        <!-- end card -->
        <div class="row">
          <div class="col-12 text-center">
            <p class="text-white-50" value
              >Already have account?
              <router-link tag="a" to="/login" class="text-white ml-1"><b>Log In</b></router-link>
              </p
            >
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
  
</template>

<style lang="scss" scoped>
.white-text{
    color:white;
    font-size:1rem;
    font-weight: 200;
    font-family: "Ubuntu",sans-serif;
}
label{
  font-weight: 200 !important;
}
i{
    position: relative;
    bottom: -30px;
    left: 18px;
    img{
        max-height: 25px;
        max-width: 20px;
    }
    &.password-icon{
      img{
        max-width: 25px;
    }
    }
}
input.input, select{
    display: block;
    width: 100%;
    height: calc(1.5em + 0.9rem + 2px);
    padding: 0.45rem 0.9rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;

    background: rgba($color: #D3AED1, $alpha: 0.5);
    border: none;
    padding-left: 50px;
    border-radius: 20px;
    color: white;
    &::placeholder {
        color: white;
        font-weight: 200;
    }
    &:focus{
        background-color: rgba($color: #D3AED1, $alpha: 0.5);
        color: white
    }
    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px #a76ca0 inset;
      -webkit-text-fill-color: white !important;
      &:focus{
        color: red;
      }
        
    }

}

.policy{
  a{
    color:#24bc66;
  }
}

button{
    background:url('~~~@assets/images/arrow.png') no-repeat right center;
    width: 40px;
    height: 40px;
    background-size: contain;
    
    border: none !important;
    &.change-pwd-btn{
    width: 40px;
    background-color: transparent !important;
    }
    &.login-btn{
        width: auto;
        padding-right: 50px;
        background-color: rgba($color: #D3AED1, $alpha: 0.5);
        border-radius: 20px;
        &:hover{
            background-color: rgba($color: #D3AED1, $alpha: 0.8);
        }
    }

}
.alert-btn {
    background-color: rgba($color: #D3AED1, $alpha: 0.5);
    font-size: 0.8rem;
    border: none;
    button{
    background-image: none;
    
    }
    &.error{
        color: #aaa0ff;
    }
    &.success{
        color: #24bc66
    }
     
}
.password-notifacation{
  color: rgba($color: #D3AED1, $alpha: 0.7);
  line-height: 1rem;
}

.highlight-text{
  font-size: 1.2rem;
}

@media (max-width: 1366px) and (orientation: landscape){
  .top-space{
    margin-top: 12vh;
  }
}

@media (max-width: 1024px) and (orientation: portrait){
  .top-space{
    margin-top: 20vh;
  }
}
@media (max-width: 768px) and (orientation: portrait){
  .top-space{
    margin-top: 10vh;
  }
}
@media (max-width: 414px){
  .top-space{
    margin-top: 0;
  }
  .form-group{
    margin-bottom: 0;
  }
  .mb-2, .my-2 {
    margin-bottom: 0 !important;
  }
}
@media (max-width: 320px){
  .secondary-text{
    margin-bottom: 10px !important;
    font-size: 0.9rem;
  }
  .policy{
    font-size: 0.9rem !important;
  }
  .p-4{
    padding: 01rem!important;
  }
}


</style>
